<!-- lead-view.component.html -->
<div class="container-fluid py-3">
    <div class="d-flex justify-content-center">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link optionone" 
             [ngClass]="{'active': activeTab === 'details'}" 
             (click)="setActiveTab('details')" 
             href="javascript:void(0)">
            View Details
          </a>
        </li>
        <li class="nav-item">
          <a class="nav  -link optiontwo" 
             [ngClass]="{'active': activeTab === 'timeline'}" 
             (click)="setActiveTab('timeline')" 
             href="javascript:void(0)">
            Timeline Notes
          </a>
        </li>
      </ul>
     </div>

    <div class="row">
        <div class="col-12">
          <div class="tab-content">
            <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'details'}">
              <div *ngIf="activeTab === 'details'">
                <div class="container-fluid mb-4">
                  <div class="row mb-3" style="margin-top: 50px;">
                    <div class="col">
                      <h5 class="lead-title">Inquiry Details - {{ lead?.name }}</h5>
                    </div>
                    <div class="col text-end">
                      <button *ngIf="!editMode" class="btn btn-primary btn-sm" (click)="viewDownloadDetails(lead)">
                        <i class="bi bi-pencil-square"></i> Download Details
                      </button>
                    </div>
                  </div>
    
                  <form [formGroup]="leadForm">
                    <div class="row">
                      <!-- Left Column -->
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label class="form-label fw-bold">Name <span class="text-danger">*</span></label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.name }}</div>
                          <input *ngIf="editMode" type="text" class="form-control" formControlName="name">
                          <div *ngIf="editMode && leadForm.get('name')?.invalid && leadForm.get('name')?.touched" class="text-danger small">
                            Name is required
                          </div>
                        </div>
    
                        <div class="mb-3">
                          <label class="form-label fw-bold">Email <span class="text-danger">*</span></label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.email }}</div>
                          <input *ngIf="editMode" type="email" class="form-control" formControlName="email">
                          <div *ngIf="editMode && leadForm.get('email')?.invalid && leadForm.get('email')?.touched" class="text-danger small">
                            Valid email is required
                          </div>
                        </div>
    
                        <div class="mb-3">
                          <label class="form-label fw-bold">Departments</label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.department }}</div>
                          <input *ngIf="editMode" type="text" class="form-control" formControlName="department">
                        </div>
    
                        <!-- <div class="mb-3">
                          <label class="form-label fw-bold">Contact Person</label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.contact_person }}</div>
                          <input *ngIf="editMode" type="text" class="form-control" formControlName="contact_person">
                        </div> -->
                      </div>
    
                      <!-- Right Column -->
                      <div class="col-md-6">
    
                        <div class="mb-3">
                          <label class="form-label fw-bold">Phone</label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.phone }}</div>
                          <input *ngIf="editMode" type="text" class="form-control" formControlName="phone">
                        </div>

                        <div class="mb-3">
                            <label class="form-label fw-bold">Created On </label>
                            <div *ngIf="!editMode" class="form-control-static">{{ lead?.created }}</div>
                            <input *ngIf="editMode" type="text" class="form-control" formControlName="created">
                        </div>
    
                        <div class="mb-3">
                          <label class="form-label fw-bold">Issue</label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.issue }}</div>
                          <input *ngIf="editMode" type="text" class="form-control" formControlName="issue">
                        </div>
    
                        <div class="mb-3">
                          <label class="form-label fw-bold">Status</label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.status }}</div>
                          <select *ngIf="editMode" class="form-select" formControlName="status">
                            <option selected value="active">Active</option>
                            <option value="contacted">Contacted</option>
                            <option value="qualified">Qualified</option>
                            <option value="converted">Converted</option>
                            <option value="lost">Lost</option>
                          </select>
                        </div>
    
                        <!-- <div class="mb-3">
                          <label class="form-label fw-bold">Additional Details</label>
                          <div *ngIf="!editMode" class="form-control-static">{{ lead?.additional_info }}</div>
                          <textarea *ngIf="editMode" class="form-control" rows="3" formControlName="additional_info"></textarea>
                        </div> -->
                      </div>
                    </div>
                  </form>
  
                  <div class="modal-footer justify-content-center" *ngIf="editMode">
                    <button type="button" class="btn btn-secondary" (click)="toggleEditMode()">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="saveChanges()">Save Changes</button>
                  </div>
  
                </div>
              </div>
            </div>
                
                  <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'timeline'}">
                    <div *ngIf="activeTab === 'timeline'">
                      <div class="container-fluid mb-4">
                        <div class="row mb-3">
                          <div class="col">
                            <h5 class="lead-title">Inquiry notes for - {{ lead?.name }}</h5>
                          </div>
                          <div class="col text-end">
                            <button class="btn btn-primary btn-sm" (click)="addNewNote()">
                              <i class="bi bi-plus-circle"></i> Add New Note
                            </button>
                          </div>
                        </div>
                      
                        <div class="timeline-wrapper">
                          <div *ngIf="lead.notes_list.length === 0" class="text-center py-5">
                            <p class="text-muted">No notes available for this lead. Click "Add New Note" to create your first note.</p>
                          </div>
                        
                          <div class="timeline-grid">
                            <ng-container *ngFor="let note of lead.notes_list; let i = index">
                              <div class="timeline-card">
                                <div class="timeline-dot" [ngStyle]="{ 'background-color': note.color || '#ccc' }"></div>
                                <div class="note-card">
                                  <div class="note-header">
                                    <div class="note-date">{{ note.add_on | date:'MMMM d, y' }}</div>
                                    <div class="note-title">{{note.notes}}</div>
                                  </div>
                                  <div class="note-description">
                                    {{note.content}}
                                  </div>
                                  <!-- <div class="note-footer">Added by {{ note.added_by }}</div> -->
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
